import { render } from "./modal-tab-topup-va.vue?vue&type=template&id=7b534447&scoped=true&ts=true"
import script from "./modal-tab-topup-va.vue?vue&type=script&lang=ts"
export * from "./modal-tab-topup-va.vue?vue&type=script&lang=ts"

import "./modal-tab-topup-va.vue?vue&type=style&index=0&id=7b534447&lang=css"
import "./modal-tab-topup-va.vue?vue&type=style&index=1&id=7b534447&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b534447"]])

export default __exports__